import { useStation } from '@app/core/stations/hooks/useStation';
import { apiClient } from '@app/api';
import { useQuery } from '@tanstack/react-query';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { Segment } from '@mi-front/core';
import { ChunkPlayer } from '../../../../../../fragments/components/chunk-player/ChunkPlayer';
import { assignChunkColor } from '../../../../../../joint-fragments/helpers/helpers';
import { DisplayableChunk } from '../../../../../../fragments/types';
import { useFragmentCtx } from '../../../context/fragment-ctx';

/**
 * Renders the list of chunks for a fragment using the shared ChunkPlayer.
 * Fetches segment data for each chunk to display waveforms.
 */
export function AudioFragmentChunksList() {
  const fragment = useFragmentCtx();
  const station = useStation(fragment.stationId);

  const query = useQuery({
    queryKey: ['fragment-with-segments', fragment.id],
    queryFn: () =>
      Promise.all(
        fragment.chunks.map<Promise<DisplayableChunk>>((chunk, index) =>
          apiClient.segments
            .fetchRange(fragment.stationId, chunk.from, chunk.to)
            .then((segments: readonly Segment[]) => ({
              ...chunk,
              segments,
              color: assignChunkColor(index),
            })),
        ),
      ),
  });

  return (
    <QueryView query={query}>
      {(chunks) => (
        <div>
          {chunks.map((chunk, index) => (
            <ChunkPlayer
              key={chunk.from}
              chunk={chunk}
              index={index}
              totalChunks={chunks.length}
              station={station}
              editable={false}
              showHeader={chunks.length > 1}
            />
          ))}
        </div>
      )}
    </QueryView>
  );
}
